import translations from './localization/zh-Hans.json' with { type: 'json' };

const categoryTranslations: Record<string, string> = translations.categories;
const textTranslations: Record<string, string> = translations.text;
const textProperties = new Set(['insert', 'title', 'name', 'caption']);

function translateText(text: string) {
  const normalizedText = text.replace(/\s+/g, ' ').trim();
  if (normalizedText.startsWith('arrow-')) {
    return `箭头 ${normalizedText.slice('arrow-'.length)}`;
  }
  if (!/[A-Za-z]/.test(normalizedText)) return text;
  const translation = textTranslations[normalizedText];
  if (translation === undefined) {
    throw new Error(`模板文字缺少中文翻译：${text}`);
  }
  return translation;
}

function localizeContent(value: unknown): void {
  if (Array.isArray(value)) {
    value.forEach(localizeContent);
    return;
  }
  if (value && typeof value === 'object') {
    const content = value as Record<string, unknown>;
    for (const [key, child] of Object.entries(content)) {
      if (textProperties.has(key) && typeof child === 'string') {
        content[key] = translateText(child);
      } else {
        localizeContent(child);
      }
    }
  }
}

export function localizeTemplateCategory(category: string) {
  const translation = categoryTranslations[category];
  if (translation === undefined) {
    throw new Error(`模板分类缺少中文翻译：${category}`);
  }
  return translation;
}

export function localizeTemplate<T extends { name: string; content: unknown }>(
  template: T
): T {
  const content = structuredClone(template.content);
  localizeContent(content);
  return { ...template, name: translateText(template.name), content };
}
